module.exports = __webpack_public_path__ + "img/cases-brand-maxam-lazyload-41.7b59360e.jpg";